import { orgCopy } from "@/lib/ui/org";

export const documentHomeCopy = {
  departmentLabel: orgCopy.departmentLabel,
  noDepartment: orgCopy.noDepartment,
  visibilityLabel: "Кто сразу увидит файл",
  visibilityHelp:
    "Потом доступ можно выдать сотруднику, группе или отделу.",
  visibilityOrganization: "Вся организация",
  visibilityDepartment: "Только выбранный отдел",
  missingDepartment: "Чтобы ограничить отделом, выберите отдел",
  unknownDepartment: "Выберите отдел из списка",
  invalidVisibility: "Выберите, кто сразу увидит файл",
} as const;

export function documentHomeErrorMessage(code: string): string {
  if (code === "missing-department") {
    return documentHomeCopy.missingDepartment;
  }
  if (code === "unknown-department") {
    return documentHomeCopy.unknownDepartment;
  }
  if (code === "invalid-visibility") {
    return documentHomeCopy.invalidVisibility;
  }
  return code;
}

export function documentDepartmentLabel(name: string | null): string {
  return name?.trim() || documentHomeCopy.noDepartment;
}
